import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=059262a2&scoped=true"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=ts"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&id=059262a2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059262a2",
  null
  
)

export default component.exports